import React, { useEffect, useState, useContext } from "react";
import { NavLink, useLocation } from "react-router-dom";
import styles from "./sidebar-navigation.module.css";

import {
  Box,
  Grid,
  ListItemIcon,
  ListItemText,
  Typography,
  Divider,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  Avatar,
  Stack,
  Card,
  Tooltip,
  Badge,
} from "@mui/material";

import Button from "@mui/material/Button";
import Popover from "@mui/material/Popover";

import AuthContext from "../../store/auth/auth-context";
import useHttp from "../../hooks/use-http";

const ProfilemenuItems = [
  { icon: "AccountOverview", label: "Account Overview" },
  { icon: "Logout", label: "Logout" },
];

const drawerWidth = 240;

const SidebarNavigation = () => {
  const location = useLocation();

  const {
    isLoading,
    isError,
    message,
    sendRequest: getProductLists,
  } = useHttp();
  const [productListState, setProductListState] = useState([]);

  const getProductListsResponse = (res: any) => {
    // if (isAuthError===true) authCxt.logout();

    // console.log("sidebar nav list : product");

    if (res.data) {
      setProductListState(res.data);
    }
  };

  useEffect(() => {
    getProductLists(
      {
        URL: "/api/product",
        method: "GET",
        header: {
          "Content-Type": "application/json",
        },
      },
      getProductListsResponse
    );
  }, []);

  const authCxt = useContext(AuthContext);

  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(
    null
  );

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = (data: string) => {
    setAnchorEl(null);
    if (data == "Logout") authCxt.logout();
  };

  const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          width: drawerWidth,
          boxSizing: "border-box",
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <Grid
        container
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between",
          height: "100vh",
          paddingLeft: "10px",
        }}
      >
        <Box>
          <Grid item m={2}>
            <Stack>
              <img src="/assets/Primary_logo_black.svg" width="180px" />
            </Stack>
          </Grid>
          <Grid item>
            <List sx={{ pb: 0 }}>
              {["All Products"].map((text, index) => (
                
                <NavLink
                
                to={"/products"}
                className={({ isActive }) =>
                  isActive ? styles.active : styles.inactive
                }
                end
                key={index}
                //   style={{textDecoration:"none"}}

                >
                  <ListItem
                    
                    disablePadding
                    selected={"/" === location.pathname || "/products"===location.pathname}
                  >
                   
                    <ListItemButton sx={{ py: 1 }}>
                      <ListItemIcon sx={{ pr: 2, minWidth: "20px" }}>
                        <img
                          src={"/assets/icons/AllProducts.svg"}
                          width="17px"
                        />
                      </ListItemIcon>
                      <ListItemText primary={text} />
                    </ListItemButton>
                    
                  </ListItem>
                  </NavLink>
               
              ))}
            </List>

            <Divider />
            <List sx={{ pt: 0 }}>
              {productListState.map((product: any, index: number) => (
                  <NavLink
                  to={"/products/" + product.ReferenceName}
                  className={({ isActive }) =>
                    isActive ? styles.active : styles.inactive
                  }
                  end
                  key={index}
                >
                <ListItem
                  
                  disablePadding
                  selected={"/products/" + product.ReferenceName === location.pathname}
                >
                  
                    <ListItemButton sx={{ py: 1 }}>
                      <ListItemIcon sx={{ pr: 2, minWidth: "20px" }}>
                        <img
                          src={"/assets/icons/" + product.Icon + ".svg"}
                          width="17px"
                        />
                      </ListItemIcon>
                      <ListItemText primary={product.Name}></ListItemText>
                    </ListItemButton>
                  
                </ListItem></NavLink>
              ))}
            </List>
          </Grid>
        </Box>

        <Box>
          <Grid item>
            <List sx={{ pb: 1 }}>
              {["Notifications"].map((text, index) => (
                <ListItem key={index} disablePadding>
                  <ListItemButton sx={{ py: 1 }}>
                    <ListItemIcon sx={{ pr: 2, minWidth: "20px" }}>
                      {/* <StarsTwoTone fontSize={"small"} /> */}
                      <img
                        src={"/assets/icons/Notifications.svg"}
                        width="17px"
                      />
                    </ListItemIcon>
                    <ListItemText
                      primary={text}
                      //   primaryTypographyProps={{
                      //     fontSize: 12,
                      //     fontWeight: "400",
                      //   }}
                    />
                    <Typography component={"span"} sx={{ mr: 3 }}>
                      <Badge
                        badgeContent={0}
                        max={999}
                        color={"secondary"}
                        sx={{ color: "#F9F9F9" }}
                      ></Badge>
                    </Typography>
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
            {/* <Divider /> */}
            <Box mr={2} mb={2}>
              <Tooltip sx={{ p: 0, m: 0 }} title="Account settings">
                <Box
                  component={"button"}
                  sx={{
                    p: 0,
                    m: 0,
                    mb: 1,
                    width: "100%",
                    border: "none",
                    borderRadius: "5px",
                  }}
                  // id="fade-button"
                  // aria-controls={open ? "fade-menu" : undefined}
                  // aria-haspopup="true"
                  // aria-expanded={open ? "true" : undefined}
                  // onClick={handleClick}
                >
                  <Button
                    aria-describedby={id}
                    variant="contained"
                    onClick={handleClick}
                    sx={{
                      m: 0,
                      p: 0,
                      width: "100%",
                      boxShadow: 0,
                      borderRadius: "5px",
                    }}
                  >
                    <Card
                      variant="outlined"
                      sx={{ width: "100%", boxShadow: 0, borderRadius: "5px",
                      
                     }}
                      className={
                        "/account" === location.pathname
                          ? styles.settingsactive
                          : ""
                      }
                    >
                      <Grid
                        display={"flex"}
                        // alignContent={"center"}
                        sx={{ padding: "5px 5px 0 5px", maxWidth: "212px",
                        overflow: "hidden",
                        maxHeight: "95px" }}
                        justifyContent={"left"}
                      >
                        <Box sx={{ paddingRight: "5px" }}>
                          <Avatar
                            alt={authCxt.userInfo?.name}
                            src="/assets/Elements/profile-avatar33.png"
                          />
                        </Box>
                        <Box sx={{ textAlign: "left" }}>
                          <Typography variant="subtitle2">
                            {" "}
                            {authCxt.userInfo?.name}
                          </Typography>
                          <Typography
                            variant="body2"
                            sx={{ mb: 1.5 }}
                            color="text.secondary"
                          >
                            {authCxt.userInfo?.email}
                          </Typography>
                        </Box>
                      </Grid>
                    </Card>
                  </Button>
                </Box>
              </Tooltip>

              <Popover
                id={id}
                open={open}
                anchorEl={anchorEl}
                onClose={handleClose}
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "center",
                }}
                transformOrigin={{
                  vertical: "bottom",
                  horizontal: "center",
                }}
                sx={{ width: "210px" }}
              >
                {/* <Typography sx={{ p: 2 }}>The content of the Popover.</Typography> */}
                <List sx={{ pt: 0, pb: 0 }}>
                  {ProfilemenuItems.map((item, index) => (                                          
                      <NavLink
                      to={"/account"}
                      className={({ isActive }) =>
                        isActive ? styles.active : styles.inactive
                      }
                      end
                      key={index}
                    >
                      <ListItem
                      
                      disablePadding
                      selected={
                        "/account" === location.pathname && index == 0
                      }
                    >
                      
                      <ListItemButton
                        sx={{ py: "4px", width:"100%" }}
                        onClick={() => handleClose(item.label)}
                      >
                        <ListItemIcon sx={{ pr: 1, minWidth: "20px" }}>
                          {/* <StarsTwoTone fontSize={"small"} /> */}
                          <img
                            src={"/assets/icons/" + item.icon + ".svg"}
                            width="15px"
                          />
                        </ListItemIcon>
                        <ListItemText
                          primary={item.label}
                          primaryTypographyProps={{
                            fontSize: 12,
                            fontWeight: "400",
                            color: "#0B0800",
                          }}
                        />
                      </ListItemButton>
                      
                    </ListItem>
                    </NavLink>
                  ))}
                </List>
              </Popover>
            </Box>
          </Grid>
        </Box>
      </Grid>
    </Drawer>
  );
};

export default SidebarNavigation;
